import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { fg } from '@confluence/feature-gating';

import { PersistentInviteEligibleQuery } from './PersistentInviteEligibleQuery.graphql';
import type {
	PersistentInviteEligibleQuery as PersistentInviteEligibleQueryType,
	PersistentInviteEligibleQueryVariables,
} from './__types__/PersistentInviteEligibleQuery';

export async function preloadPersistentInviteButtonEligible(
	{ spaceKey }: { spaceKey?: string },
	skipSpaceQuery: boolean = false,
) {
	if (fg('confluence_nav4_global-invite')) {
		const { edition, isLicensed, userId } = getPreloaderFnContext();

		const isFreeEdition = edition === ConfluenceEdition.FREE;

		return query<PersistentInviteEligibleQueryType, PersistentInviteEligibleQueryVariables>({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: PersistentInviteEligibleQuery,
			variables: {
				spaceKey,
				skipLicenseQuery: isFreeEdition || !isLicensed || !Boolean(userId) || skipSpaceQuery,
				skipSpaceQuery: !Boolean(spaceKey),
			},
		});
	}
	return undefined;
}
